import { TranslateObject } from '@/libs/translate-text'

export type RefundType =
  | 'refund_available'
  | 'refund_available_on_site_settled'
  | 'no_refund_on_site_payment'
  | 'no_refund'
  | 'no_refund_zero'

export interface RefundInfo {
  type: RefundType
  amount: number
}

export interface CancelPolicy {
  freeCancellationDays: number
  deadline: string | null
}

export function normalizeSpaceTitle(input?: Partial<TranslateObject> | null): TranslateObject {
  return {
    ja: input?.ja ?? '',
    en: input?.en ?? '',
    ko: input?.ko ?? '',
    zh: input?.zh ?? '',
    zhTw: input?.zhTw ?? '',
  }
}

export interface SpaceReservation {
  id: string
  spaceTitle: TranslateObject
  usageFrom: string
  usageTo: string
  reservedAt: string | null
  price: number
  paymentMethod: string
  canCancel: boolean
  cancelPolicy: CancelPolicy
  isPastUsageStart: boolean
  hotelName: string
}

export interface SpaceReservationDetail extends SpaceReservation {
  keyNumber: string | null
  /** 解錠用 QR コードの有無。true のとき QR コード解錠リンクを表示する */
  hasQrCode: boolean
  universalAccessKeyUrl: string | null
  refundInfo?: RefundInfo | null
}

export interface SpaceReservationsResponse {
  reservations: SpaceReservation[]
}

export interface CancelSpaceReservationResponse {
  success: boolean
  message: string
  refundInfo: RefundInfo
}
